import {
  ApolloClient,
  createHttpLink,
  from,
  fromPromise,
  InMemoryCache,
  ApolloLink
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { apiUrl } from "config/index";
import Cookies from "js-cookie";

import { REFRESH_TOKEN_PROVIDER } from "./mutations";
import i18n from "shared/locals/i18n";

let isRefreshing = false;
let pendingRequests = [];

const resolvePendingRequests = () => {
  pendingRequests.map((callback) => callback());
  pendingRequests = [];
};

const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        switch (err.extensions.code) {
          case "UNAUTHENTICATED": {
            let forward$;

            if (!isRefreshing) {
              isRefreshing = true;
              const provider = Cookies.get("provider");
              const refreshToken = Cookies.get("refresh_token");
              forward$ = fromPromise(
                client
                  .mutate({
                    mutation: REFRESH_TOKEN_PROVIDER,
                    variables: {
                      provider,
                      refreshToken,
                    },
                  })
                  .then(() => {
                    return true;
                  })
                  .then(() => {
                    resolvePendingRequests();
                    return true;
                  })
                  .catch(() => {
                    pendingRequests = [];
                    Object.keys(Cookies.get()).forEach((key) =>
                      Cookies.remove(key),
                    );
                    const loginUrl = `${window.location.href.replace(
                      window.location.pathname,
                      "",
                    )}/login`;
                    window.location.assign(loginUrl);
                    return false;
                  })
                  .finally(() => {
                    isRefreshing = false;
                  }),
              );
            } else {
              forward$ = fromPromise(
                new Promise((resolve) => {
                  pendingRequests.push(() => resolve());
                }),
              );
            }

            return forward$.flatMap(() => forward(operation));
          }
          default: {
            return;
          }
        }
      }
    }

    if (networkError) {
      return;
    }
  },
);

const httpLink = createHttpLink({
  credentials: "include",
  uri: apiUrl,
});

const langMiddleware = new ApolloLink((operation, forward) => {
  // add the language to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'Accept-Language':i18n.resolvedLanguage || i18n.language || "en"
    }
  }));

  return forward(operation);
})


const client = new ApolloClient({
  link: from([errorLink, langMiddleware, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    },
    query: {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    },
  },
});

export default client;
